export const mockData = {
  filterRoleList: [
    { label: 'Начальник', value: 'director' },
    { label: 'Заправщик', value: 'refueller' },
  ],
  filterStatusList: [
    { label: 'Действителен', value: '1' },
    { label: 'Заблокирован', value: '2' },
  ],
  employeeList: [
    {
      id: '35dee40e-ccb8-46de-8232-429a3cb2db70',
      name: 'Чадим Макаров Вячеславович',
      role: 'Заправщик',
      status: 'Действителен',
      inn: '770512345678',
      snils: '12345678900',
      birthDate: '1987-04-15',
      email: 'chadim.makarov@example.com',
      permissions: [
        { name: 'permission1', value: 'Просмотр своих заданий' },
        { name: 'permission2', value: 'Отправка отчетов о выполненных задачах' },
      ],
    },
    {
      id: 'b2371b82-0b5f-4b4f-933f-8278d6534e49',
      name: 'Самир Рябинов Артемович',
      role: 'Директор',
      status: 'Заблокирован',
      inn: '781234567890',
      snils: '98765432100',
      birthDate: '1979-11-02',
      email: 'samir.ryabinov@example.com',
      permissions: [
        {
          name: 'permission1',
          value: 'Назначает полномочия всем сотрудникам своей организации',
        },
        { name: 'permission2', value: 'Утверждает отчеты и документы' },
        { name: 'permission3', value: 'Добавляет новых сотрудников' },
      ],
    },
  ],
};
